import React from 'react';

type Props = {};

const ProformaInvoicePage = (props: Props) => {
  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center', gap: '70%', textAlign: 'center' }}>
        <p>Click here to add custom Invoice Details</p>
        <button
          type="submit"
          style={{ padding: '6px 10px', backgroundColor: '#1365A2', color: '#F5F5F5F5', borderColor: 'transparent', fontSize: '12px' }}
          className="w-full bg-blue-500 text-white py-2 rounded-lg hover:bg-blue-600"
        >
          Create Proforma Invoice
        </button>
      </div>


    </>
  );
};

export default ProformaInvoicePage;